document.addEventListener("DOMContentLoaded", function () {
  // ✅ Detect if URL includes '/en' — English version, otherwise German (default)
  const isEnglish = window.location.href.includes("/en");

  // ✅ English (when /en in URL)
  const english = {
    // --- Static Translations ---
    "drehe das Rad und gewinne einen Rabatt!": "spin the wheel and win a discount!",
    "Trage deinen Namen und deine E-Mail-Adresse ein, drehe das Rad und sichere dir deine Gewinnchance!":
      "Enter your name and email address, spin the wheel and secure your chance to win!",
    "Gib deinen Namen ein": "Enter your name",
    "Gib deine E-Mail-Adresse ein": "Enter your email address",
    "Gib deine Telefonnummer ein": "Enter your phone number",
    "Ich stimme zu, dass meine persönlichen Daten gespeichert und zum Erhalt des Newsletters verwendet werden.":
      "I agree that my personal data will be stored and used to receive the newsletter.",
    "Versuch dein Glück!": "Try your luck!",
    "Vergiss nicht, deinen Gutscheincode zu kopieren, bevor du das Fenster schließt.":
      "Don't forget to copy your voucher code before closing the window.",
    "Du hast gewonnen!": "You won!",

    // --- Wheel Slices ---
    "Entschuldigung": "Sorry",
    "20 % RABATT": "20% OFF",
    "Fast geschafft": "Almost there",
    "Heute kein Glück": "No luck today",
    "10 % RABATT": "10% OFF",
    "Mehr Glück beim nächsten Mal!": "Better luck next time!",
    "Kostenloser Versand": "Free shipping",
    "Bezahle 3 erhalte 1 gratis": "Buy 3 get 1 free",
    "Beinahe gewonnen": "Almost won",
    "25 % RABATT": "25% OFF",

    // --- Buttons ---
    "Dreh & gewinn!": "Spin & win!",
    "Kopieren": "Copy",
    "Kopiert": "Copied",
  };

  // ✅ German (default)
  const german = {
    "spin the wheel and win a discount!": "drehe das Rad und gewinne einen Rabatt!",
    "Enter your name and email address, spin the wheel and secure your chance to win!":
      "Trage deinen Namen und deine E-Mail-Adresse ein, drehe das Rad und sichere dir deine Gewinnchance!",
    "Enter your name": "Gib deinen Namen ein",
    "Enter your email address": "Gib deine E-Mail-Adresse ein",
    "Enter your phone number": "Gib deine Telefonnummer ein",
    "I agree that my personal data will be stored and used to receive the newsletter.":
      "Ich stimme zu, dass meine persönlichen Daten gespeichert und zum Erhalt des Newsletters verwendet werden.",
    "Try your luck!": "Versuch dein Glück!",
    "Don't forget to copy your voucher code before closing the window.":
      "Vergiss nicht, deinen Gutscheincode zu kopieren, bevor du das Fenster schließt.",
    "You won!": "Du hast gewonnen!",
    "Sorry": "Entschuldigung",
    "20% OFF": "20 % RABATT",
    "Almost there": "Fast geschafft",
    "No luck today": "Heute kein Glück",
    "10% OFF": "10 % RABATT",
    "Better luck next time!": "Mehr Glück beim nächsten Mal!",
    "Free shipping": "Kostenloser Versand",
    "Buy 3 get 1 free": "Bezahle 3 erhalte 1 gratis",
    "Almost won": "Beinahe gewonnen",
    "25% OFF": "25 % RABATT",
    "Spin & win!": "Dreh & gewinn!",
    "Copy": "Kopieren",
    "Copied": "Kopiert",
  };

  const translations = isEnglish ? english : german;

  function translateElements() {
    // ✅ Regular text nodes
    document.querySelectorAll("body *").forEach(el => {
      if (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) {
        let text = el.textContent.trim();

        // ✅ Handle dynamic heading with city name variable
        if (
          isEnglish &&
          text.includes("Spezialangebot für unsere Kunden in") &&
          text.includes("drehe das Rad und gewinne einen Rabatt")
        ) {
          const cityMatch = text.match(/Spezialangebot für unsere Kunden in (.+?) drehe das Rad/);
          const city = cityMatch ? cityMatch[1].trim() : "";
          el.textContent = `Special offer for our customers in ${city} spin the wheel and win a discount!`;
          return;
        }

        if (translations[text]) {
          el.textContent = translations[text];
        }
      }
    });

    // ✅ Input placeholders
    document.querySelectorAll("input").forEach(input => {
      const ph = input.getAttribute("placeholder");
      if (translations[ph]) input.setAttribute("placeholder", translations[ph]);
    });

    // ✅ SVG text (wheel slices)
    document.querySelectorAll("svg text").forEach(t => {
      const txt = t.textContent.trim();
      if (translations[txt]) t.textContent = translations[txt];
    });

    // ✅ Copy button text (with SVG icon)
    document.querySelectorAll("button.copy-button, button.copied_text_only").forEach(btn => {
      const textNode = Array.from(btn.childNodes).find(n => n.nodeType === 3);
      if (!textNode) return;
      const btnText = textNode.textContent.trim();
      if (translations[btnText]) {
        textNode.textContent = " " + translations[btnText];
      }
    });

    // ✅ Win heading translation (with span.win_text inside)
    document.querySelectorAll("p.wheelify-text-heading").forEach(p => {
      const span = p.querySelector(".win_text");
      if (span) {
        // translate only the prefix (e.g. "Du hast gewonnen!" ↔ "You won!")
        const textBefore = p.childNodes[0]?.textContent?.trim();
        if (translations[textBefore]) {
          p.childNodes[0].textContent = translations[textBefore] + ' "';
        } else if (isEnglish && textBefore.includes("Du hast gewonnen")) {
          p.childNodes[0].textContent = 'You won!';
        } else if (!isEnglish && textBefore.includes("You won")) {
          p.childNodes[0].textContent = 'Du hast gewonnen! "';
        }
      }
    });

    // ✅ Coupon notice translation (dynamic coupon and time)
    document.querySelectorAll(".cc-spin-a-sale-clock-div").forEach(div => {
      const text = div.textContent.trim();

      if (isEnglish && text.includes("Dein Gutscheincode:") && text.includes("ist bis")) {
        // Extract coupon code & time
        const coupon = div.querySelector("strong:nth-of-type(1)")?.textContent || "{{coupon_code}}";
        const time = div.querySelector("strong:nth-of-type(2)")?.textContent || "{{time}}";
        div.innerHTML = `Your coupon code: <strong>${coupon}</strong> is reserved until <strong>${time}</strong>. You can use it at checkout.`;
      } else if (!isEnglish && text.includes("Your coupon code:") && text.includes("reserved until")) {
        const coupon = div.querySelector("strong:nth-of-type(1)")?.textContent || "{{coupon_code}}";
        const time = div.querySelector("strong:nth-of-type(2)")?.textContent || "{{time}}";
        div.innerHTML = `Dein Gutscheincode: <strong>${coupon}</strong> ist bis <strong>${time}</strong> reserviert. Du kannst ihn beim Checkout einlösen.`;
      }
    });
  }

  // ✅ Run after delay (for dynamic popup)
  setTimeout(translateElements, 2000);

  // ✅ Watch for popup or wheel being injected later
  const observer = new MutationObserver(() => translateElements());
  observer.observe(document.body, { childList: true, subtree: true });
});
